import React, { useEffect, useState } from "react";
import { validationIotCallingCampaignInput } from "src/pages/Cms/utils";
import { isDisableSubmit } from "src/utils";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";

const initialValue = {
  id: "",
  campaignId: "",
  campaignName: "",
};

function IotCallingCampaignForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateIotCallingCampaignForm = (fieldValues = values) => {
    let temp = validationIotCallingCampaignInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateIotCallingCampaignForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateIotCallingCampaignForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  console.log(errors);
  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="campaignId"
        value={values.campaignId}
        label="Campaign Id"
        type="text"
        onChange={handleOnChange}
        error={errors.campaignId}
      />

      <Controls.Input
        name="campaignName"
        value={values.campaignName}
        label="Campaign Name"
        type="text"
        onChange={handleOnChange}
        error={errors.campaignName}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default IotCallingCampaignForm;
